import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CameraOperatorsService from "../../../../services/AuraCamera/camera-operators/camer-operators.service";
import CommonPanel from "../../../common/common-panel";
import AddEditCamerOperator from "./add-edit";
const CamerOperatorCreation = () => {
  var navigate = useNavigate();
  const [UpdatedData, setUpdatedData] = useState<any>(null);
  const { id } = useParams();
  useEffect(() => {
    // id
    if (id != undefined) {
      CameraOperatorsService.GetUpdateCameraOperatorsData(id).then((res: any) => {
        if(res == "error"){
          navigate(`/aura-camera/camera-operators`);
        }
        setUpdatedData(res);
      });
    }
  }, []);

  return (
    <>
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a
              onClick={() => {
                // navigate("/aura-camera/sites");
              }}
            >
              {"Dashboard"}
            </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>{"Camera operator"}</a>
          </li>

          <li className="breadcrumb-item active" aria-current="page">
            <a>{"Camera operator creation"}</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {/* <h4 className="page-heading">{"asd"}</h4> */}
            </div>
          </div>
        </div>
      </div>
      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="card form_wrapper card-mt">
            <CommonPanel
              InnerComponent={
                <AddEditCamerOperator AllUpdateData={UpdatedData} id={id} />
              }
              Heading={`Camera operator creation`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CamerOperatorCreation;
